import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Entry Points/index.md";
import * as React from 'react';
export default {
  Content,
  React
};